import {
  AppWindow,
  Briefcase,
  Building2,
  CalendarDays,
  CircleDot,
  ClipboardCheck,
  ClipboardList,
  ContactRound,
  FilePlus2,
  FileText,
  Folder,
  Handshake,
  Info,
  Layers,
  LayoutDashboard,
  LineChart,
  List,
  ListPlus,
  MessageSquareText,
  Phone,
  Scale,
  ScrollText,
  Settings,
  Signature,
  SquareCheck,
  Tag,
  Target,
  UserRound,
  Users,
  type LucideIcon,
} from "lucide-react";

import {
  ContactIcon,
  ExpenseIcon,
  FileIcon,
  LienIcon,
  LitigationIcon,
  MatterEmailIcon,
  MatterIcon,
  MatterOverviewIcon,
  MedicalTreatmentIcon,
  NoteIcon,
  OpportunityIcon,
  PropertyDamageIcon,
  ReferralIcon,
  SettlementIcon,
  TaskIcon,
} from "@/lib/utils/iconUtils";

const PAGE_ICONS: Partial<Record<string, LucideIcon>> = {
  dashboard: LayoutDashboard,
  "apps.access": AppWindow,
  "intake.access": OpportunityIcon,
  "intake.opportunities": Target,
  "intake.leads": List,
  "intake.settings": Settings,
  "matters.access": MatterIcon,
  "matters.my": UserRound,
  "matters.all": List,
  "matters.detail": MatterOverviewIcon,
  "matters.detail.overview": MatterOverviewIcon,
  "matters.detail.parties": Info,
  "matters.detail.customFields": ClipboardCheck,
  "matters.detail.propertyDamage": PropertyDamageIcon,
  "matters.detail.emails": MatterEmailIcon,
  "matters.detail.textMessages": MessageSquareText,
  "matters.detail.liens": LienIcon,
  "matters.detail.costs": ExpenseIcon,
  "matters.detail.medicalTreatments": MedicalTreatmentIcon,
  "matters.detail.settlements": SettlementIcon,
  "matters.detail.litigation": LitigationIcon,
  "matters.detail.tasks": TaskIcon,
  "matters.detail.notes": NoteIcon,
  "matters.detail.files": FileIcon,
  "matters.detail.signatureRequests": Signature,
  "matters.reports": LineChart,
  "matters.reports.demands": ScrollText,
  "matters.reports.settlements": Handshake,
  "matters.reports.recordRequests": ClipboardList,
  "matters.reports.approachingStatutes": CalendarDays,
  "matters.reports.activity": SquareCheck,
  "matters.reports.perStatus": LineChart,
  "matters.settings": Settings,
  "massTorts.access": Layers,
  "massTorts.all": List,
  "massTorts.detail": LayoutDashboard,
  "massTorts.detail.overview": LayoutDashboard,
  "massTorts.detail.customFields": ListPlus,
  "massTorts.detail.fileGeneration": FilePlus2,
  "referrals.access": ReferralIcon,
  "referrals.all": Users,
  "referrals.settings": Settings,
  "files.access": FileIcon,
  "signatureRequests.access": Signature,
  "contacts.access": ContactIcon,
  "contacts.all": ContactRound,
  "contacts.detail": ContactRound,
  "contacts.settings": Settings,
  "firm.access": Building2,
  "firm.myFirm": Building2,
  "firm.files": FileText,
  "firm.templates": FileText,
  "firm.reports": LineChart,
  "firm.reports.auditEvents": ClipboardList,
  "firm.reports.userActivity": LineChart,
  "firm.settings": Settings,
  "firm.settings.users": Users,
  "firm.settings.phoneNumbers": Phone,
};

const SUFFIX_ICONS: Partial<Record<string, LucideIcon>> = {
  settings: Settings,
  leadSources: Settings,
  roles: UserRound,
  teams: Users,
  types: Briefcase,
  statuses: CircleDot,
  tags: Tag,
  taskPlans: SquareCheck,
  scheduledMessages: CalendarDays,
  intakeTemplates: CircleDot,
  costs: ExpenseIcon,
  litigationPlans: Scale,
  defaultFiles: Folder,
  overview: LayoutDashboard,
  tasks: TaskIcon,
  notes: NoteIcon,
  files: FileIcon,
};

export function PermissionPageIcon({ permissionId }: { permissionId: string }) {
  const suffix = permissionId.split(".").at(-1) ?? permissionId;
  const Icon = PAGE_ICONS[permissionId] ?? SUFFIX_ICONS[suffix] ?? FileText;

  return (
    <Icon className="text-muted-foreground h-4 w-4 shrink-0" aria-hidden />
  );
}
